// removed by extract-text-webpack-plugin
module.exports = {"FileCountBadge":"_3XalZLXzSD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FileCountBadge/FileCountBadge.scss
// module id = 892
// module chunks = 0